import type { Toaster } from "@blueprintjs/core";
import { createContext, useContext } from "react";

export type ToasterProps = {
  toaster?: Toaster;
};

export const ToasterContext = createContext<ToasterProps>({});

export const useToaster = () => useContext<ToasterProps>(ToasterContext);
